export const sidebarIconClasses = 'text-sm place-self-center';
